export default __webpack_public_path__ + "static/media/Success_tick.d665fce4.svg";